import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="accordion"
export default class extends Controller {
  static classes = ['activeLabel', 'inactiveLabel']

  static targets = ['button', 'content', 'label']

  static values = {
    currentItemId: String,
    key: String
  }

  toggle (event) {
    event.preventDefault()

    const button = event.target.closest('[data-accordion-target="button"]')

    if (!button) {
      return
    }

    const itemId = button.dataset.accordionItemId

    if (!itemId) {
      return
    }

    const label = button.querySelector('[data-accordion-target="label"]')

    if (this.currentItemIdValue === itemId) {
      this.currentItemIdValue = null

      this.contentTargets.forEach(content => {
        content.classList.add('hidden')
      })

      label.classList.remove(...this.activeLabelClasses)
      label.classList.add(...this.inactiveLabelClasses)

      button.classList.remove('accordion-active')
    } else {
      this.currentItemIdValue = itemId

      this.contentTargets.forEach(content => {
        if (content.dataset.accordionKey !== this.keyValue) {
          return
        }

        if (content.dataset.accordionItemId === itemId) {
          content.classList.remove('hidden')
        } else {
          content.classList.add('hidden')
        }
      })

      this.labelTargets.forEach(label => {
        if (label.dataset.accordionKey !== this.keyValue) {
          return
        }

        if (label.dataset.accordionItemId === itemId) {
          label.classList.add(...this.activeLabelClasses)
          label.classList.remove(...this.inactiveLabelClasses)
        } else {
          label.classList.add(...this.inactiveLabelClasses)
          label.classList.remove(...this.activeLabelClasses)
        }
      })

      this.buttonTargets.forEach(button => {
        if (button.dataset.accordionKey !== this.keyValue) {
          return
        }

        if (button.dataset.accordionItemId === itemId) {
          button.classList.add('accordion-active')
        } else {
          button.classList.remove('accordion-active')
        }
      })
    }
  }
}
